<template>
  <div class="appointment-schedule-head">
    <button
      class="appointment-schedule-head__buttons__day"
      v-bind:class="{ current: isToday }"
      v-on:click="emitOpenToday"
      type="button">Сегодня</button>
    <div class="appointment-schedule-head__arrows">
      <button
        class="appointment-schedule-head__arrows__left"
        v-on:click="emitOpenPrevDay"
        type="button" />
      <button
        class="appointment-schedule-head__arrows__right"
        v-on:click="emitOpenNextDay"
        type="button" />
    </div>
    <button
      class="appointment-schedule-head__buttons__calendar"
      type="button"
      v-on:click="emitCollapse">
      <time class="appointment-schedule-head__title">{{dateTitle}}</time>
    </button>
  </div>
</template>

<script>
import dateMixin from '@/mixins/dateMixin';

/**
 * @description Название события открытия расписания на сегодня.
 * @type {string}
 */
const NAME_EVENT_OPEN_DAY = 'open-day';

/**
 * @description Название события открытия расписания на сегодня.
 * @type {string}
 */
const NAME_EVENT_COLLAPSE = 'collapse';

const dayByMs = (24 * 60 * 60 * 1000);

export default {
  computed: {
    isToday() {
      return this.formatDateToISO(this.initialDate) === this.formatDateToISO(new Date());
    },
    getPeriod() {
      return this.$route.query.period ?? 'day';
    },
  },
  name: 'AppointmentScheduleHead',
  methods: {
    days() {
      return this.getPeriod === 'week' ? dayByMs * 7 : dayByMs;
    },
    emitOpenNextDay() {
      const nextDay = new Date(this.initialDate.getTime() + this.days());
      this.$emit(NAME_EVENT_OPEN_DAY, nextDay);
    },
    emitOpenPrevDay() {
      const prevDay = new Date(this.initialDate.getTime() - this.days());
      this.$emit(NAME_EVENT_OPEN_DAY, prevDay);
    },
    emitOpenToday() {
      this.$emit(NAME_EVENT_OPEN_DAY, new Date());
    },
    emitCollapse() {
      this.$emit(NAME_EVENT_COLLAPSE);
    },
  },
  props: {
    dateTitle: { type: String, default: () => '' },
    initialDate: { type: Date, default: () => new Date() },
  },
  mixins: [dateMixin],
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.appointment-schedule-head {
  display: none;
  align-items: center;
  gap: 10px;
  padding: 10px 10px;
  border-bottom: 1px solid var(--border-color);
  grid-template-columns: 90px auto 1fr;
  &__title {
    white-space: nowrap;
  }
  &__buttons {
    &__day {
      @include buttons.btn-transparent(100%, 2rem, 1rem);
      &.current {
        @include buttons.btn-blue(100%, 2rem, 1rem);
      }
    }
    &__calendar {
      display: flex;
      align-items: center;
      column-gap: 10px;
      justify-self: flex-end;
      &::after {
        content: "";
        width: 30px;
        height: 2rem;
        background-image: url('@/assets/img/calendar.svg');
        background-position: center;
      }
    }
  }
  &__arrows {
    height: 2rem;
    display: grid;
    grid-template-columns: repeat(2, 30px);
    border: 1px solid var(--action-color);
    border-radius: 4px;
    color: var(--action-color);
    &__left {
      border-right: 1px solid var(--action-color);
      background-image: url('@/assets/img/arrow/arrow-blue.svg');
      background-position: center;
    }
    &__right {
      background-image: url('@/assets/img/arrow/arrow-blue.svg');
      background-position: center;
      transform: scaleX(-1);
    }
  }
}
@media screen and (max-width: 480px) {
  .appointment-schedule-head {
    display: grid;
  }
}
@media screen and (max-width: 350px) {
  .appointment-schedule-head {
    grid-template-columns: 1fr auto;
    &__buttons__calendar{
      grid-row: 1;
      grid-column: span 2;
    }
    &__buttons__day, &__arrows {
      grid-row: 2;
    }
  }
}
</style>
